<template>
  <v-card flat>
    <v-snackbar v-model="snackbar.visible" top right>
      {{ snackbar.text }}
      <v-btn color="pink" text @click="snackbar.visible = false">Fechar</v-btn>
    </v-snackbar>
    <v-card-title>Plantas</v-card-title>
    <v-card-text>
      <v-row v-if="loading" justify="center" align="center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-row>
      <v-list v-if="!loading">
        <v-list-group v-for="(plant, i) in plants" :key="i" no-action>
          <template v-slot:activator>
            <v-list-item-title>
              <v-text-field
              @click="editItem(plant.id)"
                v-model="plant.name"
                readonly
                solo
                flat
                hide-details
                background-color="transparent"
              ></v-text-field>
            </v-list-item-title>
            <v-list-item-action>
              <!-- <v-btn icon @click="editItem(plant.name)">
                <v-icon color="blue lighten-1">mdi-pencil</v-icon>
              </v-btn> -->
              <v-btn icon @click="deleteItem(plant, plants)">
                <v-icon color="red lighten-1">mdi-trash-can</v-icon>
              </v-btn>
            </v-list-item-action>
          </template>

          <v-list-group v-for="(disease, i) in plant.diseases" :key="i" sub-group no-action>
            <template v-slot:activator>
              <v-list-item-title>
                <v-text-field
                  v-model="disease.name"
                  readonly
                  solo
                  flat
                  hide-details
                  background-color="transparent"
                ></v-text-field>
              </v-list-item-title>
            </template>
          </v-list-group>
        </v-list-group>

        <v-list-item @click="addTemplate()">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Adicionar planta</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-row v-if="!loading">
        <v-spacer />
        <v-btn @click="save()" color="primary" class="mr-3">Salvar</v-btn>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { db } from "@/firebase";

export default {
  data() {
    return {
      snackbar: {
        text: null,
        visible: false
      },
      loading: false,
      templates: [],
      plants: [],
      templatesQuerySnapshot: []
    };
  },
  async created() {
    try {
      this.loading = true;

      this.templatesQuerySnapshot = await db.collection("plants").get();
      this.templatesQuerySnapshot.forEach(documentSnapshot => {
        const plant = { id: documentSnapshot.id ,name: documentSnapshot.data().name, diseases: documentSnapshot.data().diseases };
        // console.log(plant);
        this.plants.push(plant);
      });

      this.loading = false;
    } catch (err) {
      this.snackbar.text = err.message;
      this.snackbar.visible = true;

      console.error(err);

      this.loading = false;
    }
  },
  methods: {
    async deleteItem(item, parent){
      await db.collection('plants').doc(item.id).delete()
      parent.splice(parent.indexOf(item), 1);
//      console.log('tried to delete ', disease)
    },
    editItem(plant) {
      this.$router.push({ name: "PlantsDetail", params: { plant: plant} });
      //parent.splice(parent.indexOf(item), 1);
    },
    addProva(item) {
      if (!item.provas) {
        this.$set(item, "provas", []);
      }

      const name = `Avaliação (${item.provas.length + 1})`;
      item.provas.push({
        name
      });
      //console.log(this.template);
    },
    addEtapa(item) {
      if (!item.etapas) {
        this.$set(item, "etapas", []);
      }
      const name = `Etapa (${item.etapas.length + 1})`;
      item.etapas.push({ name: name, provas: [] });
    },
    addTemplate(plantName) {
      this.$router.push({ name: "PlantsDetail", params: { plant: plantName} });
      //this.templates.push(template);
    },
    async save() {
      try {
        this.loading = true;

        //for (const template of this.templates) {
        //await db.collections(`plants`).set(template)
        //}

        this.snackbar.text = "Dados salvos com sucesso";
        this.snackbar.visible = true;

        this.loading = false;
      } catch (err) {
        this.snackbar.text = err.message;
        this.snackbar.visible = true;

        console.log(err);

        this.loading = false;
      }
    }
  }
};
</script>